import { LitElement } from 'lit'
import { property } from 'lit/decorators.js'

type Constructor<T = Record<string, unknown>> = {
  new (...args: any[]): T
  prototype: T
}

export interface ChoiceElementMixinInterface {
  checked: boolean
}

export function ChoiceElementMixin<T extends Constructor<LitElement>>(
  constructor: T,
): T & Constructor<ChoiceElementMixinInterface> {
  class ChoiceElement extends constructor {
    @property({ type: Boolean, reflect: true }) checked = false
  }

  return ChoiceElement as Constructor<ChoiceElementMixinInterface> & T
}
